import { AutopilotSidebar as BaseAutopilotSidebar } from '../AutopilotSidebar/AutopilotSidebar'

export const AutopilotSidebar = () => {
  return (
    <BaseAutopilotSidebar
      sections={[
        {
          heading: 'Why these fonts?',
          text: "We've pulled your existing brand fonts and recommend alternatives that are proven to increase your social media engagement.",
        },
        {
          heading: 'Missing your font?',
          text: 'Hit the edit button next to each selection to search for the perfect match, or book a quick 1:1 call with our team.',
        },
      ]}
    />
  )
}
